// Utility functions for cart management

export const clearCartData = () => {
  try {
    localStorage.removeItem('cart');
    console.log('Cart data cleared successfully');
    return true;
  } catch (error) {
    console.error('Error clearing cart data:', error);
    return false;
  }
};

export const getCartData = () => {
  try {
    const cartData = localStorage.getItem('cart');
    if (cartData) {
      return JSON.parse(cartData);
    }
    return null;
  } catch (error) {
    console.error('Error reading cart data:', error);
    return null;
  }
};

export const validateCartData = (cartData: any) => {
  if (!Array.isArray(cartData)) {
    return false;
  }
  
  return cartData.every(item => 
    item && 
    typeof item === 'object' && 
    item.card && 
    typeof item.card === 'object' &&
    item.card.id && 
    typeof item.card.id === 'string' &&
    typeof item.quantity === 'number' &&
    item.quantity > 0
  );
};

// Add to window object for debugging
if (typeof window !== 'undefined') {
  (window as any).clearCartData = clearCartData;
  (window as any).getCartData = getCartData;
  (window as any).validateCartData = validateCartData;
}
